const projectSectors = [
  { key: "1", name: "Energy" },
  { key: "2", name: "Industrial Processing and Product Use" },
  { key: "3", name: "Agriculture" },
  { key: "4", name: "Forestry and Other Land Use" },
  { key: "5", name: "Waste Management" }
]

export default projectSectors

export const getProjectSectorsName = (key: number | string | undefined) => {
  const projectSectorByKey = projectSectors.find(item => item.key == key)
  return projectSectorByKey ? projectSectorByKey.name : "N/A"
}
